import React from "react";
import Header from "../../components/header";
import Navbar from "../../components/navbar";
import Footer from "../../components/footer";

import Banner from "../../images/leistungen/bg_hand_herz.png";

import Image from "../../images/leistungen/rauchen.jpg"

const Rauchen = () => {
    return (
        <main> 
            <Header image={Banner}/>
            <section className="content-section">
                <Navbar />

                <div className="page-container">
                    <h1> Leistung - Raucherentwöhnung </h1>
                    <img src={Image} style={{float: "right", margin:"15px"}}/>
                    <p className="page-text">
                        
                        <b> Schritt für Schritt zum Nichtraucher </b>
                        <br />
                        Wir bieten eine Begleitung während der Raucher- Entwöhnung an, welche sich aus 5 Terminen zusammensetzt (teilweise können die Termine auch per Email absolviert werden):
                        <ol>
                            <li>Termin: Erstgespräch Raucherentwöhnung</li>
                            <li>Termin: Ende der ersten Woche</li>
                            <li>Termin: nach 2 Wochen</li>
                            <li>Termin: Ende der 3. Woche</li>
                            <li>Termin: 4 Wochen beziehungsweise, 3 Monaten nach Beginn der Raucherentwöhnung</li>
                        </ol>
                        <br /> <br />
                        Die begleitende Unterstützung setzt sich aus einem Erstgespräch mit CO Messung, Fagerström Toleranztest, Führen eines Raucherprotokolls und Motivationshilfe zum Erreichen des Zieles zusammen. Begleitend gibt es auch die Möglichkeit einer medikamentösen Behandlung (z.B. Nikotin Ersatzprodukte beziehungsweise Medikation).
                        <br /> <br />
                        Diese Leistung wird leider nur von der SVA getragen, bei allen anderen Kassen müssen die Kosten selbst bezahlt werden.
                    </p>
                </div>

            </section>
            <Footer />
        </main>
    )
}

export default Rauchen;